unit BaseRequest;
{

/* Initial. */

}
interface

type
  TBaseRequest = class
  private
    fLoginKey: String;
  public
    constructor Create(const String_LoginKey: String);
    property LoginKey: String read fLoginKey;
    function ToJSON: String; virtual;
  end;

implementation

constructor TBaseRequest.Create(const String_LoginKey: String);
begin
  fLoginKey := String_LoginKey
end;

{ Should be overridden by the sub class.}
function TBaseRequest.ToJSON: String;
begin
  Result := '';
end;

end.
